<template>
  <rmr-modal
    :value="value"
    variant="form"
    :icon="icons.mdiFileDocumentPlusOutline"
    eyebrow="Création de l’article"
    title="Vérification et préparation de l’article"
    max-width="520"
    persistent
    :closable="false"
  >
    <template #body>
      <v-card-text class="ctc-launch-progress">
        <div
          class="ctc-launch-progress__loading"
          role="status"
          aria-live="polite"
        >
          <v-progress-circular indeterminate color="primary" size="34" />
          <span>
            <strong>Création en cours…</strong>
            <small>
              Cette opération peut prendre jusqu’à une minute. Ne fermez pas la
              page.
            </small>
          </span>
        </div>
        <!-- No real-time phase reaches the browser: the operations in
             progress, never steps marked as done. -->
        <ul class="ctc-launch-progress__operations">
          <li v-for="operation in operations" :key="operation">
            {{ operation }}
          </li>
        </ul>
      </v-card-text>
    </template>
  </rmr-modal>
</template>

<script>
import { mdiFileDocumentPlusOutline } from "@mdi/js";

import RmrModal from "@/components/ui/layout/RmrModal.vue";

import { LAUNCH_PROGRESS_OPERATIONS } from "../constants";

export default {
  name: "CtcLaunchProgressModal",
  components: {
    RmrModal,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    return {
      icons: { mdiFileDocumentPlusOutline },
      operations: LAUNCH_PROGRESS_OPERATIONS,
    };
  },
};
</script>

<style lang="scss" scoped>
.ctc-launch-progress {
  display: grid;
  gap: 16px;
}

.ctc-launch-progress__loading {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 16px;
  border: 1px solid $rmr-border;
  border-radius: $rmr-radius-lg;
  background: $rmr-surface-2;

  span {
    display: grid;
    gap: 2px;
  }

  strong {
    color: $rmr-text-primary;
    font-size: $rmr-fs-base;
  }

  small {
    color: $rmr-text-muted;
    font-size: $rmr-fs-sm;
  }
}

.ctc-launch-progress__operations {
  display: grid;
  gap: 8px;
  margin: 0;
  padding: 0;
  list-style: none;

  li {
    position: relative;
    padding-left: 18px;
    color: $rmr-text-secondary;
    font-size: $rmr-fs-sm;
  }

  li::before {
    content: "";
    position: absolute;
    top: 0.55em;
    left: 4px;
    width: 6px;
    height: 6px;
    border-radius: $rmr-radius-pill;
    background: $rmr-indigo;
  }
}
</style>
